// extracted by mini-css-extract-plugin
var _1 = "Static_message__67wq8";
var _2 = "Static_wrapper__e-ONe";
export { _1 as "message", _2 as "wrapper" }
